import CSV from "components/CSV/CSV"
import Price from "components/Price/Price"
import QuickorderLineItem from "components/Quickorder/QuickorderLineItem"
import _ from "lodash"
import { observer } from "mobx-react"
import React, { Component } from "react"
import LineItem from "sdk/LineItem"
import { Button, Container, Icon, Modal, Segment, Table } from "semantic-ui-react"

import shop from "shop/shop"
import quickorderStore from "stores/quickorderStore"


const QuickorderSummary = observer( () => {
  const { productCount, positionCount, sum } = quickorderStore

  return <div className="QuickorderSummary">
    <div className="cf pv3">
      <div className="flex justify-end items-center">
        <div className="f6 black-70 pr3">{productCount} Artikel</div>
        <div className="f6 black-70 pr3">{positionCount} Positionen</div>
        <div className="f4 b"><Price>{sum}</Price></div>
      </div>
    </div>
  </div>
} )

@observer
export default class QuickorderPage extends Component {

  constructor( props ) {
    super( props )
  }

  jumpToNextLine = () => {
    const id = `typeahead-id-${quickorderStore.positions.length - 1}`
    const element = document.getElementById( id )
    element && element.focus()
  }

  render() {
    const { positions } = quickorderStore

    const { productCount, positionCount, sum } = quickorderStore

    return <div>
      <Container className="pv4">
        <h1>{translate( "Quickorder" )}</h1>
        <div className="pb3">
          <div>{translate( "Die schnelle Bestellung" )}</div>
          <div>{translate( "QUICKORDER_DESCRIPTION" )}</div>
        </div>

        <Table celled compact>
          <Table.Header>

            <Table.Row>
              <Table.HeaderCell width={1}></Table.HeaderCell>
              <Table.HeaderCell width={1}>{translate( "Nr." )}</Table.HeaderCell>
              <Table.HeaderCell width={3}>{translate( "Artikel-Nr." )}</Table.HeaderCell>
              <Table.HeaderCell width={5}>{translate( "Produkt" )}</Table.HeaderCell>
              <Table.HeaderCell width={1}>
                <div className="black-70 tc"><Icon name="truck"/></div>
              </Table.HeaderCell>
              <Table.HeaderCell width={4}>{translate("Menge")}</Table.HeaderCell>
              <Table.HeaderCell width={1} textAlign={"right"}>&nbsp;</Table.HeaderCell>
            </Table.Row>

            {positions.map( ( lineItem, index ) => {
              return <QuickorderLineItem
                id={`typeahead-id-${index}`}
                key={lineItem.key} index={index} lineItem={lineItem} onFinishPosition={this.jumpToNextLine}/>
            } )
            }

          </Table.Header>
        </Table>

        <div>
          <QuickorderSummary/>
        </div>

        <Segment>
          <div>
            <Button onClick={quickorderStore.toCart} primary floated="right">{translate( "Warenkorb" )}</Button>
            <Button onClick={quickorderStore.export} basic><Icon name="download"/> {translate( "Exportieren" )}</Button>
            <ProductImporter/>
          </div>
        </Segment>
      </Container>
    </div>
  }
}


class ProductImporter extends Component {

  state = {
    open       : false,
    openSummary: false,
    messages   : []
  }

  render() {
    const { open, openSummary, messages } = this.state

    return (
      <React.Fragment>
        <Button basic onClick={() => this.setState( { open: true } )}><Icon name="upload"/> {translate( "import" )}</Button>

        {/*SUMMARY*/}
        <Modal
          closeIcon={<Icon name="close"/>}
          open={openSummary}
          onClose={() => {
            this.setState( { openSummary: false } )
          }}
        >
          <Modal.Header>{translate( "Import erfolgreich" )}</Modal.Header>
          <Modal.Content>
            {messages.map( ( { text }, index ) => {
              return <div className={"pb2 import-log-entry"} key={index}>{text}</div>
            } )}

            <div className="pt3">
              <QuickorderSummary/>
            </div>

          </Modal.Content>
          <Modal.Actions>
            <Button color="green"
                    onClick={() => {
                      this.setState( { open: false, openSummary: false } )
                    }}
            >
              <Icon name="checkmark"/> {translate( "weiter" )}
            </Button>
          </Modal.Actions>
        </Modal>

        {/*FILE SELECTION*/}
        <Modal
          closeIcon={<Icon name="close"/>}
          open={open}
          onClose={() => {
            this.setState( { open: false } )
          }}
          size="tiny"
        >
          <Modal.Header>{translate( "import products" )}</Modal.Header>
          <Modal.Content>

            <CSV skipFirstLine onText={( { positions } ) => {
              quickorderStore.positions = []
              quickorderStore.positionById = new Map()

              const messages = []
              let byId = new Map()
              positions.forEach( ( position, i ) => {
                let index = i + 1
                let p = byId.get( position.id )
                if ( p ) {
                  let oldCount = p.count
                  p.count = Number( p.count ) + Number( position.count )
                  messages.push( {
                    text: <div>
                      <div className={"black"}>{p.id} {p.count} Stück ({translate( "Zusammengefasst" )})</div>
                      <div className="black-60">#{p.__index} {p.id}: {oldCount} {translate( "piece" )}</div>
                      <div className="black-60">#{index} {position.id}: {position.count} {translate( "piece" )}</div>
                    </div>
                  } )
                } else {
                  position.__index = index
                  byId.set( position.id, position )
                }
              } )

              let mergedList = [...byId.entries()].map( p => p[ 1 ] )

              console.log( "RESULT", { mergedList, positions } )
              _.each( mergedList, (product => {
                  const lineItem = new LineItem( product.id, Number( product.count ), () => {
                    // TODO: Debounce
                    quickorderStore.debouncedCalculate()
                  } )
                  quickorderStore.positions.push( lineItem )
                })
              )
              quickorderStore.checkDirty()
              this.setState( { openSummary: true, open: false, messages } )
            }
            }/>

          </Modal.Content>

          <div className="bg-silver pa4">
            <p>{translate( "UPLOAD_NOTIFICATION" )}<a
              download={`Bestellvorlage.csv`}
              href="/Bestellvorlage.csv">{`Bestellvorlage.csv`}</a>.</p>
          </div>

          {/*<Modal.Actions>*/}
          {/*/!*<Button positive icon="checkmark" labelPosition="right" content="Yes" />*!/*/}
          {/*</Modal.Actions>*/}
        </Modal>
      </React.Fragment>

    )
  }
}



// WEBPACK FOOTER //
// ./src/theme/lucht/pages/quickorder/QuickorderPage.js